import { useContext } from 'react';
import { FormContext, WidgetContext } from './contexts';
import type { FieldValue, FormState } from './types';

export function useFormSelector<
  T extends FieldValue = FieldValue,
  K extends string = string
>() {
  const { state } = useContext(FormContext);

  return state as FormState<T, K>;
}

export function useFormDispatch() {
  const { dispatch } = useContext(FormContext);
  return dispatch;
}

export function useWidgetSelector() {
  const { state } = useContext(WidgetContext);
  return state;
}

export function useWidgetDispatch() {
  const { dispatch } = useContext(WidgetContext);
  return dispatch;
}
